import { render, staticRenderFns } from "./MasterPrivado.vue?vue&type=template&id=feb315fa&"
import script from "./MasterPrivado.vue?vue&type=script&lang=js&"
export * from "./MasterPrivado.vue?vue&type=script&lang=js&"
import style0 from "./MasterPrivado.vue?vue&type=style&index=0&scope=true&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MasterPrivado.vue"
export default component.exports